import Vue from "vue";
import router from "../../router";

//set Headers payload
const authHeader = process.env.VUE_APP_REQUEST_HEADER;
const headers = {};
headers[authHeader] = process.env.VUE_APP_HUB_API_KEY;

export default {
    namespaced: true,
    state: () => ({
      loadingSalesOffers: false,
      salesOffers: [],
    }),
    mutations: {
      setLoadingSalesOffers(state, item) {
        state.loadingSalesOffers = item
      },
      loadSalesOffers(state, items) {
        state.salesOffers = items;
      },
      updateSalesOfferStatus(state, payload) {
        const offer = state.salesOffers.find((offer) => {
          return offer.id === payload.id;
        });
        offer.status_oferta = payload.status_oferta;
        offer.contact_date = payload.contactDate;
        offer.contact_type = payload.contactType;
        offer.pending_reason = payload.pending_reason;
        offer.reject_reason = payload.reject_reason;
      }
    },
    actions: {
      async countSalesClientOffers( context, clientId) {
         const url = process.env.VUE_APP_HUB_API_HOST + "api/clients/" + clientId + "/count-sales-offers";

         try {
           const res = await Vue.http.get(url, { headers: headers })
           return res.data
         } catch (error) {
            console.log(error);
         }
      },
      fetchSalesClientOffers({ commit }, clientId) {
        commit("setLoadingSalesOffers", true);

        const url = process.env.VUE_APP_HUB_API_HOST + "api/clients/" + clientId + "/sales-offers";
       
        Vue.http.get(url, {
          headers: headers,
        })
        .then(response => {
          commit("loadSalesOffers", response.data);
          commit("setLoadingSalesOffers", false);
        })
        .catch(error => {
          console.log(error);
          commit("setLoadingSalesOffers", false);
        });
      },
      async sendAnalysisRequest(context, payload) {
        const url = process.env.VUE_APP_HUB_API_HOST + "api/sales-offers/send-analysis-request";

        try {
          const res = await Vue.http.post(url, payload, { headers: headers })
          // console.log(res.data)
          router.push({
            query: M.toast({
              html: res.data.message,
              classes: "green"
            }),
          });
        } catch (error) {
           console.log(error);
         }
      }
    }
}